module.exports = __webpack_public_path__ + "static/media/cia01.ffe9f95c.png";